import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { 
  MenuOutlined, 
  ShoppingCartOutlined, 
} from '@ant-design/icons';
import { push } from 'connected-react-router';

// Local
import { resetEnv, setCurrentHomeView } from 'modules/ui/actions';

import * as Styled from './styled';

// import logo from 'assets/images/logo.png';
// import logo from 'assets/images/Logo-IKI_H500.jpg';

// Inner
import MenuModal from './components/MenuModal';
import HelpDeskModal from 'components/HelpDeskModal';

/**
 * Layout
 */
class Layout extends React.Component {
  state = {
    collapsed: false,
    displayMenuModal: false,
    displayHelpDeskModal: false
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  handleOnVisitBasket = () => {
    this.props.setCurrentHomeView('basket')
    this.props.push('/configurator')
  }

  render() {
    const { props: { auth } } = this;

    if (this.props.location.pathname.includes('/giftcard')) {
      return (
        <div>
          {this.props.children}
        </div>
      )
    }

    if (!auth.token) {
      return (
        <Styled.StyledLayout
          theme={this.props.ui.theme}
        >
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20}}>
            <img src={`${process.env.REACT_APP_S3_FILES_URL}${this.props.theme.logo}`} width={200} alt="Ikomiris" />
          </div>

          {this.props.children}
        </Styled.StyledLayout>
      )
    }

    return (
      <Styled.StyledLayout
        theme={this.props.ui.theme}
      >
        <MenuModal
          visible={this.state.displayMenuModal}
          onOk={() => this.setState({ displayMenuModal: false })}
          onCancel={() => this.setState({ displayMenuModal: false })}
          setCurrentHomeView={this.props.setCurrentHomeView}
          setDisplayHelpDeskModal={() => this.setState({ displayHelpDeskModal: true })}
        />

        {
          this.state.displayHelpDeskModal && (
            <HelpDeskModal 
              visible={this.state.displayHelpDeskModal}
              onOk={() => this.setState({ displayHelpDeskModal: false })}
            />
          )
        }
    
        <Styled.StyledHeader>
          <div style={{ display: 'flex' }}>
            <a href={this.props.theme.tenantBrandUrl || "https://www.ikomiris.com"} rel="noreferrer" target="_blank">
              <img src={`${process.env.REACT_APP_S3_FILES_URL}${this.props.theme.logo}`}  height={40} style={{ marginTop: 3, marginLeft: 10 }} alt="Ikomiris" />
            </a>

            <div style={{ marginLeft: 'auto', display: 'flex'}}>

              {
                this.props.ui.globalBasket.length > 0 && (
                  <div style={{ marginRight: 10, }} onClick={this.handleOnVisitBasket}>
                    <ShoppingCartOutlined 
                      style={{ marginTop: 12, fontSize: 20, cursor: 'pointer', color: '#53b297' }}
                    />
                  </div>
                )
              }

              <MenuOutlined 
                style={{  marginRight: 10, marginTop: 13, fontSize: 18, cursor: 'pointer', color: '#53b297' }}
                onClick={() => this.setState({ displayMenuModal: true })}
              />
            </div>
          </div>

        </Styled.StyledHeader>
        {this.props.children}
      </Styled.StyledLayout>
    );
  }
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui
})

const dispatchToProps = {
  resetEnv,
  setCurrentHomeView,
  push,
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Layout));